export const payrollRosterPath = (businessId: string) =>
  `/businesses/${businessId}/payroll_roster`;

export const payrollRosterDraftPath = (businessId: string) =>
  `${payrollRosterPath(businessId)}/draft`;

export const payrollRosterPublishPath = (businessId: string) =>
  `${payrollRosterPath(businessId)}/publish`;

export const payrollRosterSyncTechniciansPath = (businessId: string) =>
  `${payrollRosterPath(businessId)}/sync_technicians`;

export const payrollRosterTechnicianSyncStatusPath = (
  businessId: string,
  syncId: string,
) => `${payrollRosterSyncTechniciansPath(businessId)}/${syncId}`;
